import settings from './settings.js'

const $inject = ['$rootScope','common','$sce']

function run(rootScope, common, sce) {
    const assignProps = ['clientTitle','clientTitleImg','stateFront'];

    assignProps.forEach((prop) => {
        if (settings[prop])
            rootScope[prop] = settings[prop]
    });

    rootScope.sideMenuDisabled = true;
    rootScope.trustHtml = (html) => sce.trustAsHtml(html);
    rootScope.openUrl = common.openUrl;

    window.ionic.Platform.ready(() => {
        if (window.StatusBar) {
            if (ionic.Platform.isAndroid())
                ionic.Platform.fullScreen(true, true);
            else
                StatusBar.styleDefault();
        }
    });
}

run.$inject = $inject

export default run